<template>
    <div class="app-container">
        <div class="form-shell" v-loading="loadingFlag">
            <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="132px">
                <!-- <el-form-item prop="sign_in_instructions" label="签到说明">
                    <Tinymce style="width:100%;" :height="500" v-model="form.sign_in_instructions" ref="tinymce" />
                </el-form-item> -->
                <el-form-item prop="disclaimer" label="免责声明">
                    <Tinymce style="width:100%;" :height="500" v-model="form.disclaimer" ref="tinymce" />
                </el-form-item>

                <el-form-item prop="user_conceal" label="用户隐私协议">
                    <Tinymce style="width:100%;" :height="500" v-model="form.user_conceal" ref="tinymce" />
                </el-form-item>

                <el-form-item prop="user_buy" label="用户购买协议">
                    <Tinymce style="width:100%;" :height="500" v-model="form.user_buy" ref="tinymce" />
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submit">保存</el-button>
                </el-form-item>

               
            </el-form>
        </div>
    </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { getSet, modifySet } from '@/api/common.js'

export default {
    data: () => ({
        rules: {
            disclaimer: [{ required: true, message: '免责声明', trigger: 'change' }],
            user_conceal: [{ required: true, message: '用户隐私协议', trigger: 'change' }],
            user_buy: [{ required: true, message: '用户购买协议', trigger: 'change' }],
        },
        form: {
            disclaimer: '',
            user_conceal: '',
            user_buy: '',
        },
        loadingFlag: false
    }),
    components: { Tinymce },
    beforeMount() {
        this.getData()
    },
    methods: {
        async getData() {
            try {
                this.loadingFlag = true

                const { data } = await getSet({
                    prefix: "text",
                    prefix2: "sign",
                    system_logs_content: "基础管理-协议设置-查看",
                    limit: 9999
                })

                this.form.disclaimer = data.data.find(item => item.key === "text.disclaimer").value
                this.form.user_conceal = data.data.find(item => item.key === "text.user_conceal").value
                this.form.user_buy = data.data.find(item => item.key === "text.user_buy").value
              
                this.loadingFlag = false
            } catch (err) {
                // this.loadingFlag=false
                console.log('获取失败', err)
            }
        },
        submit() {
            this.$refs["form"].validate(async (flag) => {
                if (flag) {
                    try {
                        this.loadingFlag = true
                        await modifySet({
                            // system_logs_content: "基础管理-协议设置-设置",
                            "text.disclaimer": {
                                value: this.form.disclaimer
                            },
                            "text.user_conceal": {
                                value: this.form.user_conceal
                            },
                            "text.user_buy": {
                                value: this.form.user_buy
                            },
                            
                        })
                        this.$message({
                            message: "修改成功",
                            type: "success"
                        })
                        this.getData()
                    } catch (err) {
                        this.loadingFlag = false
                        console.log(err)
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.form-shell {
    max-width: 880px;
}
</style>